﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractFacade = void 0;
const App_1 = require("../../App");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const gs = require("@ivanlog/gs");
class ContractFacade {
    constructor(address, web3, abi) {
        this._address = address;
        this._contract = new web3.eth.Contract(abi, address);
        this._web3 = web3;
        this._abi = abi;
    }
    updateWeb3(web3) {
        this._contract = new web3.eth.Contract(this._abi, this._address);
        this._web3 = web3;
    }
    get address() { return this._address; }
    get web3() { return this._web3; }
    _call(method, ...args) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this._contract.methods[method](...args).call();
            }
            catch (e) {
                new modalCom.DialogOk(gs.text.clearHtmlToText(e.message), "Blockchain call error at " + this._address).show();
            }
        });
    }
    _callInSilence(method, ...args) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this._contract.methods[method](...args).call();
            }
            catch (e) { }
        });
    }
    _send(method, ...args) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let gas = yield this._contract.methods[method](...args).estimateGas({ from: App_1.App.Inst.chain.account });
            }
            catch (e) {
                this._informChainError(e.data);
                return undefined;
            }
            try {
                return yield this._contract.methods[method](...args).send({ from: App_1.App.Inst.chain.account });
            }
            catch (e) {
                new modalCom.DialogOk(gs.text.clearHtmlToText(e.message), "Blockchain send error at " + this._address).show();
            }
        });
    }
    _pay(value, method, ...args) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let gas = yield this._contract.methods[method](...args).estimateGas({ value: value, from: App_1.App.Inst.chain.account });
            }
            catch (e) {
                this._informChainError(e.data);
                return undefined;
            }
            try {
                return yield this._contract.methods[method](...args).send({ value: value, from: App_1.App.Inst.chain.account });
            }
            catch (e) {
                new modalCom.DialogOk(gs.text.clearHtmlToText(e.message), "Blockchain pay error at " + this._address).show();
            }
        });
    }
    _toDecimal(wei) {
        let value = this._web3.utils.fromWei(wei, "ether");
        if (value == "0.")
            value = "0.0";
        return value;
    }
    _toEther(wei) {
        return this._toDecimal(wei);
    }
    _toWei(ether) {
        return this._web3.utils.toWei(ether, "ether");
    }
    _div(hexValue, div) {
        const decimalString = this._web3.utils.hexToNumberString(hexValue);
        const decimalNumber = BigInt(decimalString);
        const dividedNumber = decimalNumber / BigInt(div);
        const hexResult = '0x' + dividedNumber.toString(16);
        return hexResult;
    }
    _informChainError(data) {
        let message = "";
        if (data.originalError)
            data = data.originalError;
        if (data)
            if (data.message)
                message = gs.text.clearHtmlToText(data.message);
        if (message)
            message = gs.text.uppercaseFirstLetter(message);
        if (message)
            new modalCom.DialogOk("Something wrong. " + message, "Blockchain error").show();
        else
            new modalCom.DialogOk("Something wrong", "Blockchain error").show();
    }
}
exports.ContractFacade = ContractFacade;
//# sourceMappingURL=ContractFacade.js.map